/* eslint-disable no-useless-concat */
/* eslint-disable no-extend-native */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState} from 'react'
import NavigationBar from '../components/NavBar'
import { CSVLink, CSVDownload } from "react-csv"
import { useSelector, useDispatch } from 'react-redux';
import {
    addPayrollData,
    selectPayrollData
} from '../features/payroll/payrollSlice'
import { 
    selectDrivers
} from '../features/drivers/driversSlice'
import GetInvoice from '../backendHandler/invoicesRoute'
import ChangeData from '../components/ChangeData'
import PdfComponent from '../components/pdfmaker/PdfComponent'
import PdfViewer from '../components/pdfmaker/PdfViewer'

var outsideDriverArray = []
var outsideObject = {}
var outsideInvoiceNumber = 0
var outsideStartingNum = 0
var outsideRentalVan = {
    'DBS2': [],
    'DSN1': [],
    'DEX2': [],
    'DXP1': [],
    'DCF1': []
}
var outsideInvoiceData = {}
var currentWeekAdimCharge = []

var pass = null;

let rArray = []
const Summary = (props) => {

    // state for changing data
    const [ fullStandardVanRoute, setFullStandardVanRoute ] = useState(126.8)
    const [ fullLargeVanRoute, setFullLargeVanRoute ] = useState(146.8)
    const [ transportationRoute, setTransportationRoute ] = useState(100)
    const [ mFNRoute, setMFNRoute ] = useState(70)
    const [ manager, setManager ] = useState(120)
    const [ missortRoute, setMissortRoute ] = useState(126.8)
    const [ classroomTraining, setClassroomTraining ] = useState(85.5)
    const [ rideAlong, setRideAlong ] = useState(85.5)
    const [ sweeper, setSweeper ] = useState(126.8)
    const [ redoBool, setRedoBool ] = useState(false)
    const [ startingNum, setStartingNum ] = useState(0)
    const [jumper, setJumper] = useState(100)
    const [ mileRate, setMileRate ] = useState(.179)
    // const [ rescuePayment, setRescuePayment ] = useState(0)
    const [ addButton, setAddButton ] = useState(false)

    // allow for ivaylo
    const [ ivayloButtons, setIvayloButtons ] = useState(null)
    const [ changeDataButton, setChangeDataButton ] = useState(null)

    // pdf array
    const [ pdfArray, setPdfArray ] = useState([])
    const [ pdfBool, setPdfBool ] = useState(false)

    // for handling changing data
    let myObj = {
        '0': 0.0,
        'secretLocation': 0,
        'Full Standard Van Route': fullStandardVanRoute,
        'Full Large Van Route': fullLargeVanRoute,
        'Transportation Route': transportationRoute,
        'MFN Route': mFNRoute,
        'Manager': manager,
        'Missort Route': missortRoute,
        'Classroom Training': classroomTraining,
        'Ride Along': rideAlong,
        'Sweeper': sweeper,
        'Jumper': jumper,
        'Rescue Payment': 0.0,
        'Half Standard Van Route': 63.40,
        'None': 0.0
    }

    // redux
    const payroll = useSelector(selectPayrollData)
    const driversCount = useSelector(selectDrivers)
    
    const dispatch = useDispatch()
    
    // summation function
    const localSummation = (accumulator, currentValue) => { 
        return accumulator + currentValue
    }
    
    var CryptoJS = require("crypto-js");
    const [ invoiceData, setInvoiceData ] = useState(null)
    const [ summaryArray, setSummaryArray ] = useState([])
    const [ sunday, setSunday ] = useState(new Date())
    const [ firstLine, setFirstLine] = useState([])
    const [ secondLine, setSecondLine] = useState([])
    const [ dateArray, setDateArray ] = useState([])
    const [ optionsThree, setOptionsThree ] = useState([])
    const [ driverData, setDriverData ] = useState([])
    const [ thisWeeksVanData, setThisWeeksVanData ] = useState([])
    const [ selectedCity, setSelectedCity ] = useState('DBS2')
    const [ rerender, setReRender ] = useState(false)
    const [ xcelCsv, setXcelCsv ] = useState([])
    const [ changeDataBool, setChangeDataBool ] = useState(false)
    
    // backend payroll
    // using the new backend route
    const [ requestGate, setRequestGate ] = useState(false)
    const [ handleSchedule, setHandleSchedule ] = useState(null)
    const [ dateSelection, setDateSelection ] = useState(new Date())

    // for mapping the rentalVanTracker
    const [ rentalVanArray, setRentalVanArray ] = useState([])
    
    useEffect( () => {
        setHandleSchedule(
            <>
                <GetInvoice 
                    allGate={false}
                    dateSelection={dateSelection}
                />
            </>
        )
    }, [requestGate, dateSelection])
    
    // useEffect( () => {
    //     setTimeout( () => {
    //         setRentalVanArray([])
    //     }, 1000)
    // }, [rentalVanArray])
    Date.prototype.getWeek = function () {
        var firstDate = new Date(this.getFullYear(), 0, 1)
        if (this.getFullYear() === 2021) {
            return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7) - 1
        } else {
            return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7)
        }
    }

    // make an outside version
    useEffect( () => {
        outsideDriverArray = driverData
    }, [driverData])

    useEffect( () => {

        // set sunday initially
        let myDate = new Date()
        while (myDate.getDay() > 0) {
            myDate.setDate(myDate.getDate() - 1)
        }
        let aDate = new Date(myDate.setDate(myDate.getDate() - 7))
        setSunday(aDate)
    }, [])

    useEffect( () => {
        currentWeekAdimCharge = []
    }, [sunday])

    // redux mapping
    useEffect( () => {
        rArray = []
        async function postData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'POST', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
            });
            
            return response ? response.json() : console.log('no reponse')
        };
        async function getData(url = '') {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'GET', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                }
            });
            
            return response ? response.json() : console.log('no reponse')
        };
        if (payroll[sunday.toDateString()]) {
            let localObj = {...payroll[sunday.toDateString()]}
            setInvoiceData(payroll[sunday.toDateString()])
            rerender ? setReRender(false) : setReRender(true)
        } else {
            rerender ? setReRender(false) : setReRender(true)
        }
        postData('https://backendpajamas.herokuapp.com/vandatesordered/', {
            date: sunday.toDateString(),
            week: sunday.getWeek()
        }).then( response => {
            let localArray = []
            response.data.forEach( date => {
                let dateReg = date.driver_id.match(/\d/g)
                const reducer = (accumulator, currentValue) => accumulator + currentValue;
                let finalDateReg = dateReg.reduce(reducer)
                localArray.includes(finalDateReg) ? console.log('') : localArray.push(finalDateReg)
            })
            rArray = localArray
            outsideRentalVan = {
                'DBS2': [],
                'DSN1': [],
                'DEX2': [],
                'DXP1': [],
                'DCF1': []
            }
            if (invoiceData) {
                outsideInvoiceData = invoiceData
                let notIncludedDrivers = []
                let localCopiedArray = [...invoiceData[selectedCity]]
                let localArray = []
                localCopiedArray.forEach( driver => {
                    localArray.push(driver.driver_id)
                })
                response.data.forEach( vanDate => {
                    let driverNumber = vanDate.driver_id.match(/\d/g)
                    let finalNumber = '0'
                    driverNumber.forEach( returnedNumber => {
                        finalNumber += returnedNumber.toString()
                    })
                    if (!localArray.includes(parseInt(finalNumber))) {
                        notIncludedDrivers.push(parseInt(finalNumber))
                    }
                })
                let setOfNotIncluded = new Set(notIncludedDrivers)
                if (rentalVanArray.length !== Array.from(setOfNotIncluded).length) {
                    Array.from(setOfNotIncluded).forEach( ele => {
                        getData(`https://backendpajamas.herokuapp.com/drivers/${ele}/`).then( response => {
                            if (outsideRentalVan[response.location] !== undefined) {
                                if (outsideRentalVan[response.location].length !== Array.from(setOfNotIncluded).length) {
                                    outsideRentalVan[response.location].push(response)
                                } else {
                                    outsideRentalVan[response.location].push(response)
                                    setTimeout(() => {
                                        setRentalVanArray(...outsideRentalVan[response.location], response)
                                    }, 200)
                                }
                            } else {
                                if (Array.from(setOfNotIncluded).length === 1) {
                                    outsideRentalVan[response.location] = [response]
                                    setTimeout(() => {
                                        setRentalVanArray([response])
                                    }, 200)
                                } else {
                                    outsideRentalVan[response.location] = [response]
                                }
                            }
                        })
                    })
                }
                setThisWeeksVanData(response.data) 
            }
        })
    }, [payroll, sunday, invoiceData])

    // inistial get request
    useEffect( () => {
        setDateSelection(sunday)
    }, [rerender])

    useEffect( () => {
        let thisDate = new Date(sunday)
        let first = thisDate.toLocaleDateString('en-GB')
        let second = new Date(thisDate.setDate(thisDate.getDate() + 1)).toLocaleDateString('en-GB')
        let third = new Date(thisDate.setDate(thisDate.getDate() + 1)).toLocaleDateString('en-GB')
        let fourth = new Date(thisDate.setDate(thisDate.getDate() + 1)).toLocaleDateString('en-GB')
        let fifth = new Date(thisDate.setDate(thisDate.getDate() + 1)).toLocaleDateString('en-GB')
        let sixth = new Date(thisDate.setDate(thisDate.getDate() + 1)).toLocaleDateString('en-GB')
        let seventh = new Date(thisDate.setDate(thisDate.getDate() + 1)).toLocaleDateString('en-GB')
        setDateArray([
            first, second, third, fourth, fifth, sixth, seventh
        ])
    }, [sunday])

    useEffect( () => {
        let localPdfArray = []
        let rentalVanTrackerDays = false
        let currentInvIndex = 1
        let localArray = []
        let localXcelArray = []
        let localCsvArray = []
        if (invoiceData) {
            // console.log(dateArray)
            localArray.push(
                //here are the lables
                <div className='top_labels_summary'> 
                    <div className='label_boxes_summary_name_top'>
                        <h3>Name</h3>
                    </div>
                    <div className='label_boxes_summary_top'>
                        {dateArray[0]}
                    </div>
                    <div className='label_boxes_summary_top_mini'>
                        {dateArray[0].substring(0, 5)}
                    </div>
                    <div className='label_boxes_summary_top'>
                        {dateArray[1]}
                    </div>
                    <div className='label_boxes_summary_top_mini'>
                        {dateArray[1].substring(0, 5)}
                    </div>
                    <div className='label_boxes_summary_top'>
                        {dateArray[2]}
                    </div>
                    <div className='label_boxes_summary_top_mini'>
                        {dateArray[2].substring(0, 5)}
                    </div>
                    <div className='label_boxes_summary_top'>
                        {dateArray[3]}
                    </div>
                    <div className='label_boxes_summary_top_mini'>
                        {dateArray[3].substring(0, 5)}
                    </div>
                    <div className='label_boxes_summary_top'>
                        {dateArray[4]}
                    </div>
                    <div className='label_boxes_summary_top_mini'>
                        {dateArray[4].substring(0, 5)}
                    </div>
                    <div className='label_boxes_summary_top'>
                        {dateArray[5]}
                    </div>
                    <div className='label_boxes_summary_top_mini'>
                        {dateArray[5].substring(0, 5)}
                    </div>
                    <div className='label_boxes_summary_top'>
                        {dateArray[6]}
                    </div>
                    <div className='label_boxes_summary_top_mini'>
                        {dateArray[6].substring(0, 5)}
                    </div>
                    <div className='label_boxes_summary_top_end'>
                        Total
                    </div>
                </div>
            )
            //all fields with a start need information, the one without should be emty
            setFirstLine(
                [
                    '*ContactName',
                    'EmailAddress',	
                    'POAddressLine1',
                    'POAddressLine2',	
                    'POAddressLine3',
                    'POAddressLine4',
                    'POCity',
                    'PORegion',
                    'POPostalCode',
                    'POCountry',
                    '*InvoiceNumber',
                    '*InvoiceDate',	
                    '*DueDate',
                    'Total',	
                    'InventoryItemCode',	
                    'Description',	
                    '*Quantity',	
                    '*UnitAmount',	
                    '*AccountCode',	
                    '*TaxType',
                    'TaxAmount',
                    'TrackingName1',	
                    'TrackingOption1',
                    'TrackingName2',
                    'TrackingOption2',
                    'Currency'		         
                ]
            )	
            
            // var csvArray = []
            // let localCheckArray = []
            // let localCopyObj = {...invoiceData}
            // for (let dateArray in localCopyObj) {
            //     localCopyObj[dateArray].forEach( date => {
            //         if (!localCheckArray.includes(date.driver_id)) {
                        
            //         }
            //     })
            // }
            let localCopiedArray;
            if (outsideRentalVan[selectedCity] !== undefined) {
                if (outsideRentalVan[selectedCity].length > 0) {
                    // console.log(outsideRentalVan[selectedCity])
                    if (outsideRentalVan[selectedCity].length > 0) {
                        localCopiedArray = [...invoiceData[selectedCity], ...outsideRentalVan[selectedCity]]
                    }
                } else {
                    localCopiedArray = [...invoiceData[selectedCity]]
                }
            }
            let finalCopiedArray = []
            let localArrayOfRepeats = []
            localCopiedArray.forEach( ele => {
                if (localArrayOfRepeats.includes(ele.driver_id)) {
                    console.log('')
                } else {
                    localArrayOfRepeats.push(ele.driver_id)
                    finalCopiedArray.push(ele)
                }
            })
            finalCopiedArray.sort((a,b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
            let sortedData = finalCopiedArray

            sortedData.forEach( invoice => {
                    let deductionInvoiceArray = []
                    let supportInvoiceArray = []
                    let adminChargeSum = 0
                    let zeroInvoiceString = 'Zero Rated Expenses'
                    if (invoice.vat) {
                        zeroInvoiceString = '20% (Vat on Expenses)'
                    }
                        let supportArrayLabels = {}
                        let myHoverArray = [
                            // eslint-disable-next-line
                            <div><h3></h3></div>,
                            // eslint-disable-next-line
                            <div><h3></h3></div>,
                            // eslint-disable-next-line
                            <div><h3></h3></div>,
                            // eslint-disable-next-line
                            <div><h3></h3></div>,
                            // eslint-disable-next-line
                            <div><h3></h3></div>,
                            // eslint-disable-next-line
                            <div><h3></h3></div>,
                            // eslint-disable-next-line
                            <div><h3></h3></div>,
                            // eslint-disable-next-line
                            <div><h3></h3></div>
                        ]
                        let mileageArray = [
                            // eslint-disable-next-line
                            <div><h3></h3></div>,
                            // eslint-disable-next-line
                            <div><h3></h3></div>,
                            // eslint-disable-next-line
                            <div><h3></h3></div>,
                            // eslint-disable-next-line
                            <div><h3></h3></div>,
                            // eslint-disable-next-line
                            <div><h3></h3></div>,
                            // eslint-disable-next-line
                            <div><h3></h3></div>,
                            // eslint-disable-next-line
                            <div><h3></h3></div>,
                            // eslint-disable-next-line
                            <div><h3></h3></div>
                        ]
                        
                        // xcel csv row
                        let routeSum = [0, 0, 0, 0, 0, 0, 0]
                        let xcelRoute = [0,0,0,0,0,0,0]
                        let mileageXcelCsv = [0, 0, 0, 0, 0, 0, 0]
                        let mileageXcelCsvTwo = [0, 0, 0, 0, 0, 0, 0]
                        let supports = []
                        let deductions = []
                        let xcelVanRent = []
                        let adminChargeXcel = []
                        let xcelTotalArray = []
                        
                        // array for displaying and summing top row
                        let vanRent = 0
                        let vanInsurance = 0
                        let myGrossIncome = 0
                        let mileageSum = 0

                        let totalMiles = 0
                        let sumArray = [
                            0,0,0,0,0,0,0
                        ]
                        let arryRowTrackingArray = []
                        let arrayRoPushDeductionsAndSupport = []
                        let deductionArray = []

                        // function for deductions rows
                        const handleMakingDeductionRow = (data) => {
                            let deductionXcelCsv = []
                            let arrayToSubmit = []
                            data.deductionList.forEach( deduction => {
                                let localNumberArray = [0, 0, 0, 0, 0, 0, 0]
                                let localArray = [   
                                    // eslint-disable-next-line
                                    <div className='label_boxes_summary'></div>,
                                    // eslint-disable-next-line
                                    <div className='label_boxes_summary'></div>,
                                    // eslint-disable-next-line
                                    <div className='label_boxes_summary'></div>,
                                    // eslint-disable-next-line
                                    <div className='label_boxes_summary'></div>,
                                    // eslint-disable-next-line
                                    <div className='label_boxes_summary'></div>,
                                    // eslint-disable-next-line
                                    <div className='label_boxes_summary'></div>,
                                    // eslint-disable-next-line
                                    <div className='label_boxes_summary'></div>,
                                    // eslint-disable-next-line
                                    <div className='label_boxes_summary_end'>{deduction.amount}</div>
                                ]

                                deductionArray.push(
                                    {
                                        'name': deduction.name ? deduction.name : 'N/A',
                                        'amount': parseFloat(deduction.amount)
                                    }
                                )
                                deductionInvoiceArray.push(
                                    {
                                        'name': deduction.name ? deduction.name : 'N/A',
                                        'amount': parseFloat(deduction.amount)
                                    }
                                )

                                localArray[dateArray.indexOf(new Date(data.date).toLocaleDateString('en-GB'))] = (
                                    <div className='label_boxes_summary'>
                                        {deduction.amount}
                                    </div>
                                )
                                sumArray[dateArray.indexOf(new Date(data.date).toLocaleDateString('en-GB'))] -= deduction.amount
                                localNumberArray[dateArray.indexOf(new Date(data.date).toLocaleDateString('en-GB'))] = (
                                    deduction.amount
                                )

                                localNumberArray.unshift(deduction.name ? deduction.name : 'N/A')
                                localNumberArray.push(deduction.amount)
                                deductionXcelCsv = localNumberArray

                                localArray.unshift(                            // eslint-disable-next-line
                                    <div className='label_boxes_summary_name_left_column'>{deduction.name ? deduction.name : 'N/A'}</div>
                                )
            
                                arrayToSubmit.push(
                                    <div className='top_labels_summary'>
                                        {localArray}
                                    </div>
                                )
                            })

                            deductions.push(deductionXcelCsv)
                            return arrayToSubmit
                        }

                        // make the admin charge
                        const handleAdminCharge = (date) => {
                            let xcelCsvArray = [0, 0, 0, 0, 0, 0, 0]

                            let arrayToSubmit = []
                            let localArray = [   
                                // eslint-disable-next-line
                                <div className='label_boxes_summary'></div>,
                                // eslint-disable-next-line
                                <div className='label_boxes_summary'></div>,
                                // eslint-disable-next-line
                                <div className='label_boxes_summary'></div>,
                                // eslint-disable-next-line
                                <div className='label_boxes_summary'></div>,
                                // eslint-disable-next-line
                                <div className='label_boxes_summary'></div>,
                                // eslint-disable-next-line
                                <div className='label_boxes_summary'></div>,
                                // eslint-disable-next-line
                                <div className='label_boxes_summary'></div>,
                                // eslint-disable-next-line
                                <div className='label_boxes_summary_end'>{8.33}</div>
                            ]
                            localArray[dateArray.indexOf(new Date(date.date).toLocaleDateString('en-GB'))] = (
                                <div className='label_boxes_summary'>
                                    8.33
                                </div>
                            )
                            xcelCsvArray[dateArray.indexOf(new Date(date.date).toLocaleDateString('en-GB'))] = -8.33
                            localArray.unshift(                            // eslint-disable-next-line
                                <div className='label_boxes_summary_name_left_column'>Admin Charge</div>
                            )

                            arrayToSubmit.push(
                                <div className='top_labels_summary'>
                                    {localArray}
                                </div>
                            )
                            sumArray[dateArray.indexOf(new Date(date.date).toLocaleDateString('en-GB'))] -= 8.33
                            adminChargeSum = 8.33

                            xcelCsvArray.unshift('Admin Charge')
                            xcelCsvArray.push(8.33)
                            adminChargeXcel = xcelCsvArray
                            return arrayToSubmit
                        }

                        // function for support rows
                        const handleMakingSupportRow = (data) => {
                            data.supportList.forEach( support => {
                                supportInvoiceArray.push({
                                    'amount': parseFloat(support.amount),
                                    'name': support.name
                                })
                                if (supportArrayLabels[support.name]) {
                                    let sameDayBool = false
                                    supportArrayLabels[support.name].forEach( ele => {
                                        if (ele.arrayIndex === dateArray.indexOf(new Date(data.date).toLocaleDateString('en-GB'))) {
                                            sameDayBool = true
                                            ele.amount += parseFloat(support.amount)
                                        }
                                    })
                                    if (!sameDayBool) {
                                        supportArrayLabels[support.name].push(
                                            {
                                                'amount': parseFloat(support.amount),
                                                'arrayIndex': dateArray.indexOf(new Date(data.date).toLocaleDateString('en-GB'))
                                            }
                                        )
                                    }
                                } else {
                                    supportArrayLabels[support.name] = [
                                        {
                                            'amount': parseFloat(support.amount),
                                            'arrayIndex': dateArray.indexOf(new Date(data.date).toLocaleDateString('en-GB'))
                                        }
                                    ]
                                }
                            })
                        }

                        // adding in the driver van data
                        const handleMakingVanDataRow = (data, driverName, selectedLocation) => {
                            let adminBool = false
                            let localVanNumberArray = [0, 0, 0, 0, 0, 0, 0]
                            let localSumArray = [
                                0,0,0,0,0,0,0
                            ]
                            let localVanRentArray = [
                                0,0,0,0,0,0,0
                            ]
                            let vanInsuranceArray = [
                                0,0,0,0,0,0,0
                            ]
                            let localCheckAddedArray = [
                                0,0,0,0,0,0,0
                            ]
                            let arrayToSubmit = []
                            if (data) {
                                if (data.length > 0) {
                                    let localArray = [   
                                        // eslint-disable-next-line
                                        <div className='label_boxes_summary'></div>,
                                        // eslint-disable-next-line
                                        <div className='label_boxes_summary'></div>,
                                        // eslint-disable-next-line
                                        <div className='label_boxes_summary'></div>,
                                        // eslint-disable-next-line
                                        <div className='label_boxes_summary'></div>,
                                        // eslint-disable-next-line
                                        <div className='label_boxes_summary'></div>,
                                        // eslint-disable-next-line
                                        <div className='label_boxes_summary'></div>,
                                        // eslint-disable-next-line
                                        <div className='label_boxes_summary'></div>,
                                        // eslint-disable-next-line
                                        <div className='label_boxes_summary_end'></div>
                                    ]
                                    data.forEach( date => {
                                        if (parseInt(date.driver_id.match(/\d+/g)[0]) === driverName.driver_id ) {
                                            if (date.location === selectedLocation) {
                                                
                                                // check if the van is large or standard
                                                // LARGE
                                                if (date.vtype === "Large") {
                                                    // need to add a sorting variable based off large
                                                        // 1. if large
                                                            // a. rent = 12.50
                                                            // b. insurance = 17
                                                    localArray[dateArray.indexOf(new Date(date.date).toLocaleDateString('en-GB'))] = (
                                                        <div className='label_boxes_summary'>
                                                            -32.00
                                                        </div>
                                                    )
                                                    vanInsuranceArray[dateArray.indexOf(new Date(date.date).toLocaleDateString('en-GB'))] = 17.00
                                                    localVanRentArray[dateArray.indexOf(new Date(date.date).toLocaleDateString('en-GB'))] = 12.50
                                                    localSumArray[dateArray.indexOf(new Date(date.date).toLocaleDateString('en-GB'))] = 32.00
                
                                                    // bottom sum array
                                                    if (localCheckAddedArray[dateArray.indexOf(new Date(date.date).toLocaleDateString('en-GB'))] === 0) {
                                                        sumArray[dateArray.indexOf(new Date(date.date).toLocaleDateString('en-GB'))] -= 32.00
                                                        localCheckAddedArray[dateArray.indexOf(new Date(date.date).toLocaleDateString('en-GB'))] = 1
                                                    }
    
                                                    // xcel data
                                                    localVanNumberArray[dateArray.indexOf(new Date(date.date).toLocaleDateString('en-GB'))] = -32.00
                                                } else {
                                                    // STANDARD
                                                    localArray[dateArray.indexOf(new Date(date.date).toLocaleDateString('en-GB'))] = (
                                                        <div className='label_boxes_summary'>
                                                            -29.14
                                                        </div>
                                                    )
                                                    vanInsuranceArray[dateArray.indexOf(new Date(date.date).toLocaleDateString('en-GB'))] = 12.86
                                                    localVanRentArray[dateArray.indexOf(new Date(date.date).toLocaleDateString('en-GB'))] = 13.56
                                                    localSumArray[dateArray.indexOf(new Date(date.date).toLocaleDateString('en-GB'))] = 29.14
                
                                                    // bottom sum array
                                                    if (localCheckAddedArray[dateArray.indexOf(new Date(date.date).toLocaleDateString('en-GB'))] === 0) {
                                                        sumArray[dateArray.indexOf(new Date(date.date).toLocaleDateString('en-GB'))] -= 29.14
                                                        localCheckAddedArray[dateArray.indexOf(new Date(date.date).toLocaleDateString('en-GB'))] = 1
                                                    }
    
                                                    // xcel data
                                                    localVanNumberArray[dateArray.indexOf(new Date(date.date).toLocaleDateString('en-GB'))] = -29.14
                                                }
                                            }
                                        }
                                    })
                                    localArray[7] = (
                                        <div className='label_boxes_summary_end'>{Math.round((localSumArray.reduce(localSummation) + Number.EPSILON) * 100) / 100}</div>
                                    )
                                    vanRent = Math.round((localVanRentArray.reduce(localSummation) + Number.EPSILON) * 100) / 100
                                    vanInsurance = Math.round((vanInsuranceArray.reduce(localSummation) + Number.EPSILON) * 100) / 100
                                    // Math.round((localSumArray.reduce(localSummation) + Number.EPSILON) * 100) / 100
                                    if (Math.round((localSumArray.reduce(localSummation) + Number.EPSILON) * 100) / 100 > 0) {
                                        arrayToSubmit = (
                                            <div className='top_labels_summary'>
                                                <div className='label_boxes_summary_name_left_column'>Van Rent</div>
                                                {localArray}
                                            </div>
                                        )
                                    }
                                }
                            }
                            localVanNumberArray.push(Math.round((localVanNumberArray.reduce(localSummation) + Number.EPSILON) * 100) / 100)
                            localVanNumberArray.unshift('Van Rent')

                            // add admin charge
                            if (driverName) {

                                // instantiate the check for admin charge bool
                                let localAdminCheck = false

                                // check each date to see if one has an admin charge
                                driverName.datesList.forEach( date => {
                                    if (date.adminCharge) {

                                        // if there is an admin charge change the bool
                                        localAdminCheck = true

                                        // add the name to the array of present admin charges
                                        currentWeekAdimCharge.push(driverName.email)
                                    }
                                })

                                // if no admin charge was found
                                if (!localAdminCheck) {
                                    // check this array
                                    if (!currentWeekAdimCharge.includes(driverName.email)) {
                                        localVanNumberArray.push(handleAdminCharge({date: sunday.toDateString()}))
                                        currentWeekAdimCharge.push(driverName.email)
                                    }
                                }
                            }

                            xcelVanRent = localVanNumberArray
                            return arrayToSubmit
                        }

                        // function for support rows
                        const renderDataCorrectly = (key) => {
                            let localGrossArray = [0, 0, 0, 0, 0, 0, 0]
                            key.datesList.forEach( (date, DateID) => {
                                // this if statement just allows us to make sure we are matching the correct data to the correct div
                                /************************************** top row ************************************************************************/ 
                                const getAmountForRoute = (routeName, stationName) => {
                                    let returnValue = 0
                                    // if ((stationName === 'DEX2' || stationName === 'DXP1') && routeName === 'Full Standard Van Route') {
                                    //     return 134.8
                                    // } else if ((stationName === 'DEX2' || stationName === 'DXP1') && routeName === 'Full Large Van Route') {
                                    //     return 154.8
                                    // } else if ((stationName === 'DEX2' || stationName === 'DXP1') && routeName === 'Sweeper') {
                                    //     return 134.8
                                    // } else if ((stationName === 'DEX2' || stationName === 'DXP1') && routeName === 'Missort Route') {
                                    //     return 134.8
                                    // } else {
                                    //     return myObj[routeName]
                                    // }
                                    return typeof myObj[routeName] === typeof 1 ? myObj[routeName] : 0
                                }
                                myHoverArray[dateArray.indexOf(new Date(date.date).toLocaleDateString('en-GB'))] = (
                                    <div className='summary_hover_div_full'>
                                        <h3>{getAmountForRoute(date.route, date.location)}</h3>
                                    </div>
                                )
                                xcelRoute[dateArray.indexOf(new Date(date.date).toLocaleDateString('en-GB'))] = getAmountForRoute(date.route, date.location)

                                localGrossArray[dateArray.indexOf(new Date(date.date).toLocaleDateString('en-GB'))] = getAmountForRoute(date.route, date.location)
                                // add the sum to the array for the daily sum
                                // routeSum[dateArray.indexOf(new Date(date.date).toLocaleDateString('en-GB'))] += getAmountForRoute(date.route, date.location)
                                sumArray[dateArray.indexOf(new Date(date.date).toLocaleDateString('en-GB'))] += getAmountForRoute(date.route, date.location)
                                
                                /************************************** Mileage Row ************************************************************************/ 
                                if (date.finish_mileage > 0) {
                                    mileageArray[dateArray.indexOf(new Date(date.date).toLocaleDateString('en-GB'))] = (
                                        <div className='mileageOverall'>
                                            {date.finish_mileage}
                                            <h3 className='mileageInside'>
                                                {Math.round((date.finish_mileage * mileRate + Number.EPSILON) * 100) / 100}
                                            </h3>
                                        </div>
                                    )
                                    mileageXcelCsv[dateArray.indexOf(new Date(date.date).toLocaleDateString('en-GB'))] = (
                                        Math.round((date.finish_mileage * mileRate + Number.EPSILON) * 100) / 100
                                    )
                                    mileageXcelCsvTwo[dateArray.indexOf(new Date(date.date).toLocaleDateString('en-GB'))] = (
                                        date.finish_mileage
                                    )
                                }
                                sumArray[dateArray.indexOf(new Date(date.date).toLocaleDateString('en-GB'))] += Math.round((date.finish_mileage * mileRate + Number.EPSILON) * 100) / 100
                                
                                // sum the mileage
                                totalMiles += date.finish_mileage
                                mileageSum += Math.round((date.finish_mileage * mileRate + Number.EPSILON) * 100) / 100
                                /************************************** All Support ************************************************************************/ 
                                if (date.supportList.length > 0) {
                                    handleMakingSupportRow(date)
                                }
                                
                                /************************************** All Deductions ************************************************************************/ 
                                
                                if (date.deductionList.length > 0) {
                                    arrayRoPushDeductionsAndSupport.push(
                                        handleMakingDeductionRow(date)
                                    )
                                }
                                    // sumArray[dateArray.indexOf(new Date(date.date).toLocaleDateString('en-GB'))] -= parseFloat(date.deductionSum.slice(3))
                                    // sumArray[dateArray.indexOf(new Date(date.date).toLocaleDateString('en-GB'))] += parseFloat(date.supportSum.slice(3))
                                // sum for all the supports
                                if (date.adminCharge) {
                                    arrayRoPushDeductionsAndSupport.push(
                                        handleAdminCharge(date)
                                    )
                                }
                            })
                            myGrossIncome = Math.round((localGrossArray.reduce(localSummation) + Number.EPSILON) * 100) / 100
                            const handleAddingSupports = () => {
                                let finalArrayXcelCsv = []
                                let finalArray = []
                                for (let supportObj in supportArrayLabels) {
                                    let localSupportArray = [
                                        0,0,0,0,0,0,0
                                    ]
                                    let localArray = [   
                                        // eslint-disable-next-line
                                        <div className='label_boxes_summary'></div>,
                                        // eslint-disable-next-line
                                        <div className='label_boxes_summary'></div>,
                                        // eslint-disable-next-lin
                                        <div className='label_boxes_summary'></div>,
                                        // eslint-disable-next-line
                                        <div className='label_boxes_summary'></div>,
                                        // eslint-disable-next-line
                                        <div className='label_boxes_summary'></div>,
                                        // eslint-disable-next-line
                                        <div className='label_boxes_summary'></div>,
                                        // eslint-disable-next-line
                                        <div className='label_boxes_summary'></div>,
                                        // eslint-disable-next-line
                                        <div className='label_boxes_summary_end'></div>
                                    ]
                                    supportArrayLabels[supportObj].forEach( supportInnerObj => {
                                        localArray[supportInnerObj.arrayIndex] = (
                                            <div className='label_boxes_summary'>{supportInnerObj.amount}</div>
                                        )
                                        localSupportArray[supportInnerObj.arrayIndex] = parseFloat(supportInnerObj.amount)
                                    })
                                    
                                    localArray[7] = (
                                        <div className='label_boxes_summary_end'>{Math.round((localSupportArray.reduce(localSummation) + Number.EPSILON) * 100) / 100}</div>
                                    )
                                    localArray.unshift(                            // eslint-disable-next-line
                                        <div className='label_boxes_summary_name_left_column'>{supportObj ? supportObj : 'N/A'}</div>
                                    )
                                    finalArray.push(
                                        <div className='top_labels_summary'>
                                            {localArray}
                                        </div>
                                    )
                                    localSupportArray.forEach( (innerNumber, innerNumberIndex) => {
                                        sumArray[innerNumberIndex] += innerNumber
                                    })
                                    localSupportArray.push(Math.round((localSupportArray.reduce(localSummation) + Number.EPSILON) * 100) / 100)
                                    localSupportArray.unshift(supportObj)
                                    finalArrayXcelCsv.push(localSupportArray)
                                }

                                supports = finalArrayXcelCsv
                                return finalArray
                            }
                            arrayRoPushDeductionsAndSupport.unshift(handleAddingSupports())
                            // here is were we set the final row of the mileage/support/deductions.. because the loop above has now made our sums
                            mileageArray[7] = (
                                <div>
                                    {/* so this is a string literal... im using it so can display the totals with the pound sign and do the mileage math and rounding*/}
                                    {Math.round((mileageSum + Number.EPSILON) * 100) / 100}
                                </div>
                            )
            
                            const summation = (accumulator, currentValue) => { 
                                return accumulator + currentValue
                            }
                            //all being displayed in the payroll
                            localArray.push(
                                <div className='top_labels_summary'>
                                    <div className='label_boxes_summary_name'>
                                        <h3>{invoice.name}</h3>
                                    </div>                   
                                    <div className='label_boxes_summary'>
                                        {myHoverArray[0]}
                                    </div>
                                    <div className='label_boxes_summary'>
                                        {myHoverArray[1]}
                                    </div>
                                    <div className='label_boxes_summary'>
                                        {myHoverArray[2]}
                                    </div>
                                    <div className='label_boxes_summary'>
                                        {myHoverArray[3]}
                                    </div>
                                    <div className='label_boxes_summary'>
                                        {myHoverArray[4]}
                                    </div>
                                    <div className='label_boxes_summary'>
                                        {myHoverArray[5]}
                                    </div>
                                    <div className='label_boxes_summary'>
                                        {myHoverArray[6]}
                                    </div>
                                    <div className='label_boxes_summary_end'>
                                        {Math.round((myGrossIncome + Number.EPSILON) * 100) / 100}
                                    </div>
                                </div>
                            )
                            localArray.push(
                                <div className='top_labels_summary'>
                                    <div className='label_boxes_summary_name_left_column'>
                                        Mileage
                                    </div>
                                    <div className='label_boxes_summary'>
                                        {mileageArray[0]}
                                    </div>
                                    <div className='label_boxes_summary'>
                                        {mileageArray[1]}
                                    </div>
                                    <div className='label_boxes_summary'>
                                        {mileageArray[2]}
                                    </div>
                                    <div className='label_boxes_summary'>
                                        {mileageArray[3]}
                                    </div>
                                    <div className='label_boxes_summary'>
                                        {mileageArray[4]}
                                    </div>
                                    <div className='label_boxes_summary'>
                                        {mileageArray[5]}
                                    </div>
                                    <div className='label_boxes_summary'>
                                        {mileageArray[6]}
                                    </div>
                                    <div className='label_boxes_summary_end'>
                                        {mileageArray[7]}
                                    </div>
                                </div>
                            )
                            localArray.push(handleMakingVanDataRow(thisWeeksVanData, key, selectedCity))
                            let totalArray = [
                                Math.round((sumArray[0] + Number.EPSILON) * 100) / 100,
                                Math.round((sumArray[1] + Number.EPSILON) * 100) / 100,
                                Math.round((sumArray[2] + Number.EPSILON) * 100) / 100,
                                Math.round((sumArray[3] + Number.EPSILON) * 100) / 100,
                                Math.round((sumArray[4] + Number.EPSILON) * 100) / 100,
                                Math.round((sumArray[5] + Number.EPSILON) * 100) / 100,
                                Math.round((sumArray[6] + Number.EPSILON) * 100) / 100
                            ]
                            localArray.push(arrayRoPushDeductionsAndSupport)
                            xcelTotalArray = [...totalArray]
                            xcelTotalArray.push(Math.round((totalArray.reduce(summation) + Number.EPSILON) * 100) / 100)
                            xcelTotalArray.unshift('Total')


                            localArray.push(
                                <div className='top_labels_summary'>
                                    <div className='label_boxes_summary_name_left_column_blue'>
                                        Total
                                    </div>
                                    <div className='label_boxes_summary_total'>
                                        {totalArray[0]}
                                    </div>
                                    <div className='label_boxes_summary_total'>
                                        {totalArray[1]}
                                    </div>
                                    <div className='label_boxes_summary_total'>
                                        {totalArray[2]}
                                    </div>
                                    <div className='label_boxes_summary_total'>
                                        {totalArray[3]}
                                    </div>
                                    <div className='label_boxes_summary_total'>
                                        {totalArray[4]}
                                    </div>
                                    <div className='label_boxes_summary_total'>
                                        {totalArray[5]}
                                    </div>
                                    <div className='label_boxes_summary_total'>
                                        {totalArray[6]}
                                    </div>
                                    <div className='label_boxes_summary_end_total'>
                                        {Math.round((totalArray.reduce(summation) + Number.EPSILON) * 100) / 100}
                                    </div>
                                </div>
                            )
                            localPdfArray.push([{'name': invoice.name}, {'total': Math.round((totalArray.reduce(summation) + Number.EPSILON) * 100) / 100}, {'miles': mileageArray ? mileageArray[7].props.children : 0}, {'deductions': deductionInvoiceArray}, {'vanRent': xcelVanRent}, {'support': supportInvoiceArray}, {'date': sunday}, {'invoiceNumber': currentInvIndex}, {'station': selectedCity}, {'adminCharge': adminChargeXcel}, {'vat': invoice.vat}, {'grossIncome': Math.round((myGrossIncome + Number.EPSILON) * 100) / 100}])
                        }

                        renderDataCorrectly(invoice)
                        let myDateHere = new Date()
                        let transientDate = new Date(sunday)
                        let mostRecentSunday = new Date(transientDate.setDate(transientDate.getDate() + 6)).toLocaleDateString('en-GB')
                        // function for making spaced rows

                        let locationDriver = ''
                        let accountCodeFromDriver = 0
                        // get the driver data

                        const makeSpacedRows = (driversName, weekData, startDate, endDate, description, quantity, unitAmount, accountCode, taxType) => {
                            let array = [
                                driversName,
                                '',
                                '',
                                '',
                                '',
                                '',
                                '',
                                '',
                                '',
                                '',
                                weekData,
                                startDate,
                                endDate,
                                '',
                                '',
                                description,
                                quantity,
                                unitAmount,
                                accountCode,
                                taxType,
                                '',
                                '',
                                '',
                                '',
                                '',
                                '',
                            ]
                            return array
                        }
                        let theWeek = `WEEK ${sunday.getWeek()}`
                        let invNum = sunday.getWeek() + sunday.getFullYear()-2020
                        let arrayForcsv = [
                            'Gross Income & BYOD',
                            'Miles',
                            'Support',
                            'Fuel Deduction',
                            'Admin Charge',
                            'HiVis',
                            'Key Chain',
                            'Van Rent',
                            'Insurance'
                        ]
                        ///////////////////////////////////////////////////////////////////////////////////////////////
                        function create_current_invoice(){

                            outsideInvoiceNumber++
                            let localLocation = 'DBS2'
                            if (invoice.datesList.length > 0) {
                                if (invoice.datesList[0].location === 'CT' || invoice.datesList[0].location === 'RT') {
                                    localLocation = invoice.location
                                } else {
                                    localLocation = invoice.datesList[0].location
                                }
                            } else {
                                localLocation = invoice.location
                            }
                            const summation = (accumulator, currentValue) => { 
                                return Math.abs(accumulator) + Math.abs(currentValue)
                            }
                            if (rArray.includes(invoice.driver_id.toString())) {
                                return outsideInvoiceNumber.toString().concat('R').concat(' ').concat(localLocation)
                            } else {
                                return outsideInvoiceNumber.toString().concat(' ').concat(localLocation)
                            }
                            // let id = (sunday.getWeek()*currentInvIndex*driversCount.length)+(sunday.getFullYear().toString()[3]*52*driversCount.length)
                        }
                        ///////////////////////////////////////////////////////////////////////////////////////////////
                        let currentInvoiceValue = create_current_invoice()

                        // deductions for csv
                        let deductionCsvArray = []
                        if (deductionArray.length > 0) {
                            deductionArray.forEach( element => {
                                if (element.name === "Fuel Card Charge") {
                                    deductionCsvArray.push(
                                        makeSpacedRows(invoice.name, `${theWeek}` + ` ` +  `INV ${currentInvoiceValue}` + ` ` +  `${locationDriver}`, sunday.toLocaleDateString('en-GB'), mostRecentSunday, element.name, -1, Math.round((parseFloat(element.amount)/1.2 + Number.EPSILON) * 100) / 100, 225, '20% (Vat on Income)'),
                                    )
                                } else if (element.name === 'Deduction') {
                                    deductionCsvArray.push(
                                        makeSpacedRows(invoice.name, `${theWeek}` + ` ` +  `INV ${currentInvoiceValue}` + ` ` +  `${locationDriver}`, sunday.toLocaleDateString('en-GB'), mostRecentSunday, element.name, -1, Math.round((parseFloat(element.amount) + Number.EPSILON) * 100) / 100, 206, 'Zero Rated Income'),
                                    )
                                } else {
                                    deductionCsvArray.push(
                                        makeSpacedRows(invoice.name, `${theWeek}` + ` ` +  `INV ${currentInvoiceValue}` + ` ` +  `${locationDriver}`, sunday.toLocaleDateString('en-GB'), mostRecentSunday, element.name, -1, element.amount, 268, '20% (Vat on Income)'),
                                    )
                                }
                            })
                        }

                        let supportCsvArray = []
                        for (let key in supportArrayLabels) {
                            let localSupportArray = [
                                0,0,0,0,0,0,0
                            ]
                            let totalAmount = 0
                            supportArrayLabels[key].forEach( element => {
                                localSupportArray[element.arrayIndex] = parseFloat(element.amount)
                            })
                            totalAmount = Math.round((localSupportArray.reduce(localSummation) + Number.EPSILON) * 100) / 100
                            supportCsvArray.push(
                                makeSpacedRows(invoice.name, `${theWeek}` + ` ` +  `INV ${currentInvoiceValue}` + ` ` +  `${locationDriver}`, sunday.toLocaleDateString('en-GB'), mostRecentSunday, key, 1, totalAmount, 322, zeroInvoiceString),
                            )
                        }

                        // end comment
                        localCsvArray.push(
                            makeSpacedRows(invoice.name, `${theWeek}` + ` ` +  `INV ${currentInvoiceValue}` + ` ` +  `${locationDriver}`, sunday.toLocaleDateString('en-GB'), mostRecentSunday, arrayForcsv[0], 1, Math.round((myGrossIncome + Number.EPSILON) * 100) / 100, 320, zeroInvoiceString),
                            makeSpacedRows(invoice.name, `${theWeek}` + ` ` +  `INV ${currentInvoiceValue}` + ` ` +  `${locationDriver}`, sunday.toLocaleDateString('en-GB'), mostRecentSunday, arrayForcsv[1], Math.round((totalMiles + Number.EPSILON) * 100) / 100, mileRate, 335, zeroInvoiceString),
                        )
                        if (deductionCsvArray.length > 0) {
                            deductionCsvArray.forEach( element => {
                                localCsvArray.push(element)
                            })                 
                        }
                        if (supportCsvArray.length > 0) {
                            supportCsvArray.forEach( element => {
                                localCsvArray.push(element)
                            })                 
                        }
                        if (vanRent > 0) {
                            localCsvArray.push(
                                makeSpacedRows(invoice.name, `${theWeek}` + ` ` +  `INV ${currentInvoiceValue}` + ` ` +  `${locationDriver}`, sunday.toLocaleDateString('en-GB'), mostRecentSunday, arrayForcsv[7], -1, Math.round((vanRent + Number.EPSILON) * 100) / 100 , 262, '20% (Vat on Income)'),
                                makeSpacedRows(invoice.name, `${theWeek}` + ` ` +  `INV ${currentInvoiceValue}` + ` ` +  `${locationDriver}`, sunday.toLocaleDateString('en-GB'), mostRecentSunday, arrayForcsv[8], -1, vanInsurance, 267, 'Exempt Income')
                            )
                        }
                        if (adminChargeSum > 0) {
                            localCsvArray.push(
                                makeSpacedRows(invoice.name, `${theWeek}` + ` ` +  `INV ${currentInvoiceValue}` + ` ` +  `${locationDriver}`, sunday.toLocaleDateString('en-GB'), mostRecentSunday, arrayForcsv[4], -1, 8.33, 268, '20% (Vat on Income)')
                            )
                        }

                        ///////////////// xcel /////////////////////////
                        // routes
                        xcelRoute.push(Math.round((xcelRoute.reduce(localSummation) + Number.EPSILON) * 100) / 100)
                        xcelRoute.unshift(invoice.name)
                        localXcelArray.push(xcelRoute)

                        // mileage
                        if ((Math.round((mileageXcelCsv.reduce(localSummation) + Number.EPSILON) * 100) / 100) > 0) {
                            let localMileageArray = mileageXcelCsvTwo
                            localMileageArray.push(Math.round((mileageXcelCsv.reduce(localSummation) + Number.EPSILON) * 100) / 100)
                            localMileageArray.unshift('mileage')
                            localXcelArray.push(localMileageArray)
                        }

                        // supports
                        supports.forEach( supportArray => {
                            localXcelArray.push(supportArray)
                        })

                        // deductions
                        deductions.forEach( deductionArray => {
                            localXcelArray.push(deductionArray)
                        })

                        // van rent
                        if (xcelVanRent.slice(1).reduce(localSummation) !== 0) {
                            localXcelArray.push(xcelVanRent) 
                        }

                        // admin charge
                        if (adminChargeXcel[8] === 8.33) {
                            localXcelArray.push(adminChargeXcel)
                        }

                        // totals
                        localXcelArray.push(xcelTotalArray)

                    // handle the making of the xcel data
                    localXcelArray.push([' ', ' ', ' '])
            })  
        }
        setSecondLine(localCsvArray)
        setSummaryArray(localArray)
        setXcelCsv(localXcelArray)
        setPdfArray(localPdfArray)
        // , , 
    }, [sunday, selectedCity, redoBool, rentalVanArray, invoiceData, thisWeeksVanData])

    // csv stuff  
    let data = [
        firstLine
    ];
    if (secondLine) {
        secondLine.forEach( element => {
            data.push(element)
        })
    }

    // xcel csv
    let xcelData = [];
    const makeXcelData = () => {
        // labels
        let localDateLabels = ['Name']
        dateArray.forEach( date => {
            localDateLabels.push(
                date
            )
        })
        localDateLabels.push('Total')

        // first row - route amounts
        xcelData.unshift(localDateLabels)

        // if there is data
        if (xcelCsv) {
            xcelCsv.forEach( element => {
                xcelData.push(element)
            })
        }
    }
    makeXcelData()

    const handleSelectSunday = (e, dateOne, dateTwo) => {
        setSummaryArray([])
        // change the fields in the backend
        async function postData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'POST', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
                });

            return response ? response.json() : console.log('no reponse')
        };

        // postData('https://backendpajamas.herokuapp.com/invoices/', {
        //     date: new Date(dateOne).toDateString(),
        //     week: new Date(dateOne).getWeek()
        // }).then( (response) => {
        //     setInvoiceData(response.data)
        //     postData('https://backendpajamas.herokuapp.com/vandatesordered/', {
        //         date: new Date(dateOne).toDateString(),
        //         week: new Date(dateOne).getWeek()
        //     }).then( response => {
        //         setThisWeeksVanData(response.data.dates) 
        //     })
        // })
        setSunday(new Date(dateOne))
    }

    // get sundays
    const getSundaysTwo = () => {
        let sundays = []
        let currentDate = new Date()
        for (let i = -81; i < 40; i++) {
            let dateInner = new Date(currentDate.getFullYear(), currentDate.getMonth(), i)
            if (dateInner.getDay() === 0) {
                sundays.push(
                    <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectSunday(e, `${dateInner.toDateString()}`, `${dateInner.toDateString()}`)}><a href="#0" id="makeMeWhiteli" >Week: {dateInner.getWeek()} | {dateInner.toLocaleDateString('en-GB')}</a></li>
                    )
            }
        }
        return sundays
    }

    // make the list of sundays for the backend
    useEffect( () => {
        setOptionsThree(getSundaysTwo())
    }, [])

    // handle setting the city abbreviation
    const handleSelectCity = (e, theCity) => {
        setSelectedCity(theCity)
        outsideInvoiceNumber = outsideStartingNum
    }

    // function for handling return data
    const handleReturnData = (fullStandardVanRoutea, fullLargeVanRoutea, transportationRoutea, mFNRoutea, managera, missortRoutea, classroomTraininga, rideAlonga, sweepera, startingNuma, mileRatea) => {
        setFullStandardVanRoute(fullStandardVanRoutea)
        setFullLargeVanRoute(fullLargeVanRoutea)
        setTransportationRoute(transportationRoutea)
        setMFNRoute(mFNRoutea)
        setManager(managera)
        setMissortRoute(missortRoutea)
        setClassroomTraining(classroomTraininga)
        setRideAlong(rideAlonga)
        setSweeper(sweepera)
        setStartingNum(startingNuma - 1)
        outsideStartingNum = startingNuma - 1
        outsideInvoiceNumber = startingNuma - 1
        setChangeDataBool(false)
        setMileRate(mileRatea)
        setTimeout( () => {
            redoBool ? setRedoBool(false) : setRedoBool(true);
        }, [500])
    }

    var fullContent
    const handleShowPdfs = () => {
        pdfBool ? setPdfBool(false) : setPdfBool(true)
    }

    if (props.superUser) {
        if (changeDataBool && !pdfBool) {
            fullContent = (
                <ChangeData 
                    fullStandardVanRoute={fullStandardVanRoute}
                    fullLargeVanRoute={fullLargeVanRoute}
                    transportationRoute={transportationRoute}
                    mFNRoute={mFNRoute}
                    manager={manager}
                    missortRoute={missortRoute}
                    classroomTraining={classroomTraining}
                    rideAlong={rideAlong}
                    sweeper={sweeper}
                    handleReturnData={handleReturnData}
                    returnButton={addButton}
                    mileRate={mileRate}
                />
            )
        } else if (summaryArray.length > 0 && !pdfBool) {
            fullContent = (
                <div className='home_content'>
                    <NavigationBar title='Payroll' superUser={props.superUser ? true : false} email={props.user_email}/>
                    <div className='main_content_driver_summary'>
                        <div className='topSelectors'>
                            <div className='payrollDatesList'>
                                <nav className="menu">
                                    <ol>
                                        <li className="menu-item" id="makeMeWhite"><a id="makeMeWhite" href="#0">Week: {sunday.getWeek()} | {sunday.toLocaleDateString('en-GB')}</a>
                                            <ol className="sub-menu" id='payrollDropDown'>
                                                {optionsThree}
                                            </ol>
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                            <div className='payrollDatesList'>
                                <nav className="menu">
                                    <ol>
                                        <li className="menu-item" id="makeMeWhite"><a href="#0" id="makeMeWhite">{selectedCity}</a>
                                            <ol className="sub-menu" id="makeMeWhite">
                                                <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectCity(e, 'DBS2')}><a id="makeMeWhiteli" href="#0">DBS2</a></li>
                                                <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectCity(e, 'DSN1')}><a id="makeMeWhiteli" href="#0">DSN1</a></li>
                                                <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectCity(e, 'DEX2')}><a id="makeMeWhiteli" href="#0">DEX2</a></li>
                                                <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectCity(e, 'DXP1')}><a id="makeMeWhiteli" href="#0">DXP1</a></li>
                                                <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectCity(e, 'DCF1')}><a id="makeMeWhiteli" href="#0">DCF1</a></li>
                                            </ol>
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        <div className='compliance_add_driver_button_submit_top' >
                            <span className='span_in_complaince_button' onClick={() => setChangeDataBool(true)}>Change Data</span>
                        </div>
                        </div>
                        <div className='summary_data'>
                            {summaryArray}
                        </div>
                        <div className='downloadButtons'>
                            <CSVLink data={data} className='compliance_add_driver_button_submit' id='summary_button'>
                                <span className='span_in_complaince_button'>Xero CSV</span> 
                            </CSVLink>    
                            <CSVLink data={xcelData} className='compliance_add_driver_button_submit' id='summary_button'>
                                <span className='span_in_complaince_button'>Payroll</span> 
                            </CSVLink>    
                            <div className='compliance_add_driver_button_submit' id='summary_button' onClick={handleShowPdfs}>
                                <span className='span_in_complaince_button'>Pdfs</span> 
                            </div>
                        </div>
                    </div>
                </div>
            )
        } else if (pdfBool) {
            fullContent = <PdfViewer data={pdfArray} returnScreen={() => handleShowPdfs()}/>
        } 
        else {
            fullContent = (
                <div className='home_content'>
                <NavigationBar title='Payroll' superUser={props.superUser ? true : false} email={props.user_email}/>
                    <div className='complianceLoading'>
                        <div className='containerForLoader'>
                            <div class="spinner">
                                <div class="bounce1"></div>
                                <div class="bounce5"></div>
                                <div class="bounce4"></div>
                                <div class="bounce3"></div>
                                <div class="bounce2"></div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    } else {
        if (changeDataBool && !pdfBool) {
            fullContent = (
                <ChangeData 
                    fullStandardVanRoute={fullStandardVanRoute}
                    fullLargeVanRoute={fullLargeVanRoute}
                    transportationRoute={transportationRoute}
                    mFNRoute={mFNRoute}
                    manager={manager}
                    missortRoute={missortRoute}
                    classroomTraining={classroomTraining}
                    rideAlong={rideAlong}
                    sweeper={sweeper}
                    handleReturnData={handleReturnData}
                    returnButton={addButton}
                    mileRate={mileRate}
                />
            )
        } else if (summaryArray.length > 0 && !pdfBool) {
            fullContent = (
                <div className='home_content'>
                    <NavigationBar title='Payroll' superUser={props.superUser ? true : false} email={props.user_email}/>
                    <div className='main_content_driver_summary'>
                        <div className='topSelectors'>
                            <div className='payrollDatesList'>
                                <nav className="menu">
                                    <ol>
                                        <li className="menu-item" id="makeMeWhite"><a id="makeMeWhite" href="#0">Week: {sunday.getWeek()} | {sunday.toLocaleDateString('en-GB')}</a>
                                            <ol className="sub-menu" id='payrollDropDown'>
                                                {optionsThree}
                                            </ol>
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                            <div className='payrollDatesList'>
                                <nav className="menu" id="makeMeWhite">
                                    <ol>
                                        <li className="menu-item" id="makeMeWhite"><a href="#0" id="makeMeWhite">{selectedCity}</a>
                                            <ol className="sub-menu" id="makeMeWhite">
                                                <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectCity(e, 'DBS2')}><a id="makeMeWhiteli" href="#0">DBS2</a></li>
                                                <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectCity(e, 'DSN1')}><a id="makeMeWhiteli" href="#0">DSN1</a></li>
                                                <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectCity(e, 'DEX2')}><a id="makeMeWhiteli" href="#0">DEX2</a></li>
                                                <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectCity(e, 'DXP1')}><a id="makeMeWhiteli" href="#0">DXP1</a></li>
                                                <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectCity(e, 'DCF1')}><a id="makeMeWhiteli" href="#0">DCF1</a></li>
                                            </ol>
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                        <div className='summary_data'>
                            {summaryArray}
                        </div>
                    </div>
                </div>
            )
        } else if (pdfBool) {
            fullContent = <PdfViewer data={pdfArray} returnScreen={() => handleShowPdfs()}/>
        } 
        else {
            fullContent = (
                <div className='home_content'>
                <NavigationBar title='Payroll' superUser={props.superUser ? true : false} email={props.user_email}/>
                    <div className='complianceLoading'>
                        <div className='containerForLoader'>
                            <div class="spinner">
                                <div class="bounce1"></div>
                                <div class="bounce5"></div>
                                <div class="bounce4"></div>
                                <div class="bounce3"></div>
                                <div class="bounce2"></div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }
    
    return (
        <>
            {handleSchedule}
            {fullContent}
        </>
    )
}

export default Summary